naiveShouldComponentUpdate = require 'lib/util/naive-should-component-update'
React = require 'react'
MemberAvatar = require 'views/member/member-avatar-react'
t = require('views/internal/recup-with-helpers')('select_member')
l = require 'lib/localize'

module.exports = class AutocompleteMemberAvatar extends React.Component
  displayName: 'AutocompleteMemberAvatar'

  constructor: (props) ->
    super(props)

  shouldComponentUpdate: naiveShouldComponentUpdate

  render: t.renderable ->
    {
      active,
      username,
      email,
      confirmed,
      joined,
      fullName,
      memberType,
      idOrganizations,
      onMouseDown,
      onRemoveClick,
      displayDetails,
      displayOrg,
      displayUsername
    } = @props

    if displayUsername
      title = "#{ fullName } (#{ username })"
    else
      title = fullName || email

    # using mousedown instead of click on the option allows us to
    # select the option and then have the input blur happen afterwards
    t.div '.member-container', {
      onMouseDown
    }, =>
      if displayDetails
        t.div '.member', =>
          t.createElement MemberAvatar, @props

      t.div '.member-info', ->
        t.div '.full-name', ->
          t.text title

        if displayOrg? && idOrganizations && displayOrg.id in idOrganizations
          t.span '.quiet.sub-name', {
            style:
              marginRight: 4
            }, ->
            t.text displayOrg.get('displayName')

        if displayDetails
          if joined
            if memberType? == 'ghost'
              t.span '.quiet.sub-name', ->
                t.text l('invited')
            else
              t.span '.quiet.sub-name', ->
                t.text "(#{l('joined')})"
          else
            if !confirmed
              t.span '.quiet.sub-name', ->
                t.format 'unconfirmed-user'
            else if !active
              t.span '.quiet.sub-name', ->
                t.format 'inactive-account'

      if onRemoveClick
        t.a '.icon-sm .icon-close', { onClick: onRemoveClick, href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-member-autocomplete-avatar.coffee